import _ from "lodash";

const getPeriscopeUrlParams = (periscopeDashboard, filters) => {
  if (!periscopeDashboard || !filters) {
    return;
  }

  const selectedFilterIds = filters.map(f => f.value);
  const dashboardFilters = _.remove(
    _.cloneDeep(periscopeDashboard.filters),

    f => selectedFilterIds.indexOf(f.id) > -1
  );

  return {
    dashboard: periscopeDashboard.dashboard || periscopeDashboard,
    dashboardFilters
  };
};

export default getPeriscopeUrlParams;
